import api from '~/services/api';
import { ProductKitInterface } from './product-kit-interface';

class ProductKitService {
  getProductKits() {
    return api.get(`/product-kit`);
  }

  getProductKitById(id: String) {
    return api.get(`/product-kit/${id}`);
  }

  createProductKit(payload: ProductKitInterface) {
    return api.post(`/product-kit`, payload);
  }

  deleteProductKit(id: String) {
    return api.delete(`/product-kit/${id}`);
  }

  updateProductKit(payload: ProductKitInterface) {
    return api.put(`/product-kit`, payload);
  }
}

export default new ProductKitService();
